import React, { useEffect, useState } from 'react';
import {
  Box,
  HeadingText,
  GDSStyleObject,
  FormField,
  TextInput,
  Select,
  StackLayout,
  UtilityText,
  Fieldset,
  Radio,
} from '@leagueplatform/genesis-core';
import {
  formatPhoneNumber,
  stateOption,
  isEmpty,
  isNotEmpty,
  isValidatePhoneLength,
  updateFormData,
  isNoSpace,
  isValidZipCodeLength,
} from '../../../helpers';
import { IS_POLICY_HOLDER_PATIENT } from '../../../../../types/online-forms.types';

export function ExaminerDispenserInformation(props: any) {
  const { errorHandling, nextButtonClicked, isValidateForm, footerToBottom } =
    props;
  const [exPhoneError, setExPhoneError] = useState<string>('');
  const [exZipCodeError, setExZipCodeError] = useState<string>('');
  const [disPhoneError, setDisPhoneError] = useState<string>('');
  const [disZipCodeError, setDisZipCodeError] = useState<string>('');
  const [isDisSameError, setIsDisSameError] = useState<string>('');
  const [form, setForm] = useState({
    examinerName: '',
    examinerAddressLine1: '',
    examinerAddressLine2: '',
    examinerCity: '',
    examinerState: '',
    examinerZipCode: '',
    examinerSLN: '',
    examinerPhoneNumber: '',
    isDispenserSame: '',
    dispenserName: '',
    dispenserAddressLine1: '',
    dispenserAddressLine2: '',
    dispenserCity: '',
    dispenserState: '',
    dispenserZipCode: '',
    dispenserSLN: '',
    dispenserPhoneNumber: '',
  });
  const [errors, setErrors] = useState({
    examinerName: false,
    examinerAddressLine1: false,
    examinerCity: false,
    examinerState: false,
    examinerZipCode: false,
    examinerPhoneNumber: false,
    isDispenserSame: false,
    dispenserName: false,
    dispenserAddressLine1: false,
    dispenserCity: false,
    dispenserState: false,
    dispenserZipCode: false,
    dispenserPhoneNumber: false,
  });

  const exFormField =
    isEmpty(form.examinerName) ||
    isEmpty(form.examinerAddressLine1) ||
    isEmpty(form.examinerCity) ||
    isEmpty(form.examinerState) ||
    isEmpty(form.examinerZipCode) ||
    isValidZipCodeLength(form.examinerZipCode) ||
    isEmpty(form.examinerPhoneNumber) ||
    isValidatePhoneLength(form.examinerPhoneNumber) ||
    isEmpty(form.isDispenserSame);

  const disFormField =
    isEmpty(form.dispenserName) ||
    isEmpty(form.dispenserAddressLine1) ||
    isEmpty(form.dispenserCity) ||
    isEmpty(form.dispenserState) ||
    isEmpty(form.dispenserZipCode) ||
    isValidZipCodeLength(form.dispenserZipCode) ||
    isEmpty(form.dispenserPhoneNumber) ||
    isValidatePhoneLength(form.dispenserPhoneNumber);

  const isValid =
    isNotEmpty(form.examinerName) &&
    isNotEmpty(form.examinerAddressLine1) &&
    isNotEmpty(form.examinerCity) &&
    isNotEmpty(form.examinerState) &&
    isNotEmpty(form.examinerZipCode) &&
    !isValidZipCodeLength(form.examinerZipCode) &&
    isNotEmpty(form.examinerPhoneNumber) &&
    !isValidatePhoneLength(form.examinerPhoneNumber) &&
    isNotEmpty(form.isDispenserSame) &&
    (form.isDispenserSame === 'YES' ||
      (form.isDispenserSame === 'NO' &&
        isNotEmpty(form.dispenserName) &&
        isNotEmpty(form.dispenserAddressLine1) &&
        isNotEmpty(form.dispenserCity) &&
        isNotEmpty(form.dispenserState) &&
        isNotEmpty(form.dispenserZipCode) &&
        !isValidZipCodeLength(form.dispenserZipCode) &&
        isNotEmpty(form.dispenserPhoneNumber) &&
        !isValidatePhoneLength(form.dispenserPhoneNumber)));

  useEffect(() => {
    footerToBottom(false);
  }, [footerToBottom]);

  useEffect(() => {
    if (
      exFormField ||
      errors.isDispenserSame ||
      errors.examinerZipCode ||
      errors.examinerPhoneNumber ||
      (form.isDispenserSame === 'NO' &&
        (disFormField ||
          errors.dispenserZipCode ||
          errors.dispenserPhoneNumber))
    ) {
      errorHandling(false);

      if (isEmpty(form.examinerZipCode)) {
        setExZipCodeError('Zip code required.');
      } else if (isValidZipCodeLength(form.examinerZipCode)) {
        setExZipCodeError('Enter a valid zip code.');
      } else {
        setExZipCodeError('');
      }

      if (isEmpty(form.examinerPhoneNumber)) {
        setExPhoneError("Examiner's phone number is required.");
      } else if (isValidatePhoneLength(form.examinerPhoneNumber)) {
        setExPhoneError('Enter a valid phone number.');
      } else {
        setExPhoneError('');
      }

      if (isEmpty(form.isDispenserSame)) {
        setIsDisSameError('This selection is required.');
      } else {
        setIsDisSameError('');
      }

      if (isEmpty(form.dispenserZipCode)) {
        setDisZipCodeError('Zip code required.');
      } else if (isValidZipCodeLength(form.dispenserZipCode)) {
        setDisZipCodeError('Enter a valid zip code.');
      } else {
        setDisZipCodeError('');
      }

      if (isEmpty(form.dispenserPhoneNumber)) {
        setDisPhoneError("Dispenser's phone number is required");
      } else if (isValidatePhoneLength(form.dispenserPhoneNumber)) {
        setDisPhoneError('Enter a valid phone number.');
      } else {
        setDisPhoneError('');
      }
    } else {
      errorHandling(true);
    }
  }, [exFormField, errors, errorHandling, form, disFormField]);

  useEffect(() => {
    if (nextButtonClicked) {
      if (!isValid) {
        setErrors({
          examinerName: isEmpty(form.examinerName),
          examinerAddressLine1: isEmpty(form.examinerAddressLine1),
          examinerCity: isEmpty(form.examinerCity),
          examinerState: isEmpty(form.examinerState),
          examinerZipCode:
            isEmpty(form.examinerZipCode) ||
            isValidZipCodeLength(form.examinerZipCode),
          examinerPhoneNumber:
            isEmpty(form.examinerPhoneNumber) ||
            isValidatePhoneLength(form.examinerPhoneNumber),
          isDispenserSame: isEmpty(form.isDispenserSame),
          dispenserName: isEmpty(form.dispenserName),
          dispenserAddressLine1: isEmpty(form.dispenserAddressLine1),
          dispenserCity: isEmpty(form.dispenserCity),
          dispenserState: isEmpty(form.dispenserState),
          dispenserZipCode:
            isEmpty(form.dispenserZipCode) ||
            isValidZipCodeLength(form.dispenserZipCode),
          dispenserPhoneNumber:
            isEmpty(form.dispenserPhoneNumber) ||
            isValidatePhoneLength(form.dispenserPhoneNumber),
        });
      }
    }
  }, [nextButtonClicked, isValid, form]);

  const updateErrorState = (value: string, id: string) => {
    if (id === 'examinerPhoneNumber') {
      if (isEmpty(value)) {
        setExPhoneError("Examiner's phone number is required.");
        setErrors((prevState) => ({
          ...prevState,
          examinerPhoneNumber: true,
        }));
      } else if (isValidatePhoneLength(value)) {
        setExPhoneError('Enter a valid phone number.');
        setErrors((prevState) => ({
          ...prevState,
          examinerPhoneNumber: true,
        }));
      } else {
        setExPhoneError('');
        setErrors((prevState) => ({
          ...prevState,
          examinerPhoneNumber: false,
        }));
      }
    } else if (id === 'examinerZipCode') {
      if (isEmpty(value)) {
        setExZipCodeError('Zip code required.');
        setErrors((prevState) => ({
          ...prevState,
          examinerZipCode: true,
        }));
      } else if (isValidZipCodeLength(value)) {
        setExZipCodeError('Enter a valid zip code.');
        setErrors((prevState) => ({
          ...prevState,
          examinerZipCode: true,
        }));
      } else {
        setExZipCodeError('');
        setErrors((prevState) => ({
          ...prevState,
          examinerZipCode: false,
        }));
      }
    } else if (id === 'isDispenserSame') {
      setDisPhoneError('');
      setDisZipCodeError('');
      setErrors((prevState) => ({
        ...prevState,
        isDispenserSame: false,
        dispenserName: false,
        dispenserAddressLine1: false,
        dispenserCity: false,
        dispenserState: false,
        dispenserZipCode: false,
        dispenserPhoneNumber: false,
      }));
    } else if (id === 'dispenserPhoneNumber') {
      if (isEmpty(value)) {
        setDisPhoneError("Dispenser's phone number is required");
        setErrors((prevState) => ({
          ...prevState,
          dispenserPhoneNumber: true,
        }));
      } else if (isValidatePhoneLength(value)) {
        setDisPhoneError('Enter a valid phone number.');
        setErrors((prevState) => ({
          ...prevState,
          dispenserPhoneNumber: true,
        }));
      } else {
        setDisPhoneError('');
        setErrors((prevState) => ({
          ...prevState,
          dispenserPhoneNumber: false,
        }));
      }
    } else if (id === 'dispenserZipCode') {
      if (isEmpty(value)) {
        setDisZipCodeError('Zip code required.');
        setErrors((prevState) => ({
          ...prevState,
          dispenserZipCode: true,
        }));
      } else if (isValidZipCodeLength(value)) {
        setDisZipCodeError('Enter a valid zip code.');
        setErrors((prevState) => ({
          ...prevState,
          dispenserZipCode: true,
        }));
      } else {
        setDisZipCodeError('');
        setErrors((prevState) => ({
          ...prevState,
          dispenserZipCode: false,
        }));
      }
    } else {
      const nextErrorState = {
        ...errors,
        [id]: isEmpty(value),
      };
      setErrors(nextErrorState);
    }
  };

  const onUpdateField = (event: any) => {
    const { value, id } = event.target;
    const nextFormState = {
      ...form,
      [event.target.id]: /^\s/.test(event.target.value)
        ? ''
        : event.target.value,
    };
    setForm(nextFormState);
    updateErrorState(event.target.value, event.target.id);

    if (id === 'examinerName' || id === 'dispenserName') {
      setForm((prevState) => ({
        ...prevState,
        [id]: isNoSpace(value) ? '' : value?.replace(/[^a-zA-Z0-9 \-']+/gi, ''),
      }));
    }

    if (id === 'examinerCity' || id === 'dispenserCity') {
      setForm((prevState) => ({
        ...prevState,
        [id]: isNoSpace(value) ? '' : value?.replace(/[^a-zA-Z ]+/gi, ''),
      }));
    }

    if (id === 'dispenserZipCode' || id === 'examinerZipCode') {
      setForm((prevState) => ({
        ...prevState,
        [id]: isNoSpace(value) ? '' : value?.replace(/[^0-9]+/gi, ''),
      }));
    }

    if (id === 'dispenserPhoneNumber' || id === 'examinerPhoneNumber') {
      setForm((prevState) => ({
        ...prevState,
        [id]: isNoSpace(value) ? '' : formatPhoneNumber(value),
      }));
    }

    if (id === 'examinerSLN' || id === 'dispenserSLN') {
      setForm((prevState) => ({
        ...prevState,
        [id]: isNoSpace(value) ? '' : value.replace(/[^a-zA-Z0-9 ]+/gi, ''),
      }));
    }
  };

  useEffect(() => {
    const pInfo = JSON.parse(sessionStorage.getItem('formData') || '{}');
    if (pInfo) {
      setForm({
        examinerName: pInfo?.examinerName,
        examinerAddressLine1: pInfo?.examinerAddressLine1,
        examinerAddressLine2: pInfo?.examinerAddressLine2,
        examinerCity: pInfo?.examinerCity,
        examinerState: pInfo?.examinerState,
        examinerZipCode: pInfo?.examinerZipCode,
        examinerSLN: pInfo?.examinerSLN,
        examinerPhoneNumber: pInfo?.examinerPhoneNumber,
        isDispenserSame: pInfo?.isDispenserSame,
        dispenserName: pInfo?.dispenserName,
        dispenserAddressLine1: pInfo?.dispenserAddressLine1,
        dispenserAddressLine2: pInfo?.dispenserAddressLine2,
        dispenserCity: pInfo?.dispenserCity,
        dispenserState: pInfo?.dispenserState,
        dispenserZipCode: pInfo?.dispenserZipCode,
        dispenserSLN: pInfo?.dispenserSLN,
        dispenserPhoneNumber: pInfo?.dispenserPhoneNumber,
      });
    }
  }, []);

  const updateIsDispenserSame = (e: any) => {
    const { value } = e.target;
    if (value === 'Yes') {
      setIsDisSameError('');
      setForm((prevState) => ({
        ...prevState,
        isDispenserSame: 'YES',
        dispenserName: '',
        dispenserAddressLine1: '',
        dispenserCity: '',
        dispenserState: '',
        dispenserZipCode: '',
        dispenserSLN: '',
        dispenserPhoneNumber: '',
      }));
    } else {
      setIsDisSameError('');
      setForm((prevState) => ({
        ...prevState,
        isDispenserSame: 'NO',
        dispenserName: '',
        dispenserAddressLine1: '',
        dispenserCity: '',
        dispenserState: '',
        dispenserZipCode: '',
        dispenserSLN: '',
        dispenserPhoneNumber: '',
      }));
    }
    isValidateForm(false);
    updateErrorState(value, 'isDispenserSame');
  };

  const onBlurField = (event: any) => {
    updateErrorState(event.target.value, event.target.id);
  };

  const onKeyPressField = (event: any) => {
    updateErrorState(event.target.value, event.target.id);
  };

  useEffect(() => {
    if (form) {
      updateFormData(form);
    }
  }, [form]);

  return (
    <StackLayout
      css={
        {
          backgroundColor: 'White',
          maxWidth: '800px',
        } as GDSStyleObject
      }
      horizontalAlignment="center"
    >
      <Box
        css={
          {
            display: 'flex',
            flexDirection: 'column',
            padding: '$three $two $two $two',
          } as GDSStyleObject
        }
      >
        <Box
          css={
            {
              display: 'flex',
              flexDirection: 'column',
              padding: '$none $two',
            } as GDSStyleObject
          }
        >
          <HeadingText
            level="1"
            size={{
              '@initial': 'xxl',
              '@mobile': 'xl',
              '@mobileLandscape': 'xl',
              '@tablet': 'xl',
              '@laptop': 'xxl',
              '@desktop': 'xxl',
            }}
          >
            Direct Reimbursement Claim Form
          </HeadingText>
        </Box>
        <Box
          css={
            {
              display: 'flex',
              flexDirection: 'column',
              padding: '$one $two',
              width: '100%',
            } as GDSStyleObject
          }
        >
          <Box
            css={
              {
                display: 'flex',
                flexDirection: 'column',
              } as GDSStyleObject
            }
          >
            <HeadingText
              level="3"
              size={{
                '@initial': 'xl',
                '@mobile': 'lg',
                '@mobileLandscape': 'lg',
                '@tablet': 'xl',
                '@laptop': 'xl',
                '@desktop': 'xl',
              }}
            >
              Step 4: Examiner&apos;s Information
            </HeadingText>
          </Box>
          <Box>
            <Box
              css={
                {
                  display: 'flex',
                  flexDirection: 'column',
                  padding: '$one $none',
                } as GDSStyleObject
              }
            >
              <FormField
                id="examinerName"
                label="Examiner Name (First, MI, Last)"
                statusIconLabel="Error"
                inputStatus={errors.examinerName ? 'error' : undefined}
                statusMessage={
                  errors.examinerName ? "Examiner's name is required" : ''
                }
              >
                <TextInput
                  name="examinerName"
                  id="examinerName"
                  value={form.examinerName}
                  onChange={onUpdateField}
                  onBlur={onBlurField}
                  onKeyPress={onKeyPressField}
                  maxLength={50}
                />
              </FormField>
            </Box>
            <Box
              css={
                {
                  display: 'flex',
                  flexDirection: 'column',
                  padding: '$one $none',
                } as GDSStyleObject
              }
            >
              <FormField
                id="examinerAddressLine1"
                label="Examiner Address Line 1"
                statusIconLabel="Error"
                inputStatus={errors.examinerAddressLine1 ? 'error' : undefined}
                statusMessage={
                  errors.examinerAddressLine1
                    ? "Examiner's address line 1 required."
                    : ''
                }
              >
                <TextInput
                  name="examinerAddressLine1"
                  id="examinerAddressLine1"
                  value={form.examinerAddressLine1}
                  onChange={onUpdateField}
                  maxLength={50}
                  onBlur={onBlurField}
                  onKeyPress={onKeyPressField}
                />
              </FormField>
            </Box>
            <Box
              css={
                {
                  display: 'flex',
                  flexDirection: 'column',
                  padding: '$one $none',
                } as GDSStyleObject
              }
            >
              <FormField
                id="examinerAddressLine2"
                label="Examiner Address Line 2 (Optional)"
              >
                <TextInput
                  name="examinerAddressLine2"
                  id="examinerAddressLine2"
                  value={form.examinerAddressLine2}
                  onChange={onUpdateField}
                  maxLength={50}
                />
              </FormField>
            </Box>
            <Box
              css={
                {
                  display: 'flex',
                  flexDirection: 'column',
                  padding: '$one $none',
                } as GDSStyleObject
              }
            >
              <FormField
                id="examinerCity"
                label="City"
                statusIconLabel="Error"
                inputStatus={errors.examinerCity ? 'error' : undefined}
                statusMessage={errors.examinerCity ? 'City required.' : ''}
              >
                <TextInput
                  name="examinerCity"
                  id="examinerCity"
                  value={form.examinerCity}
                  onChange={onUpdateField}
                  onBlur={onBlurField}
                  onKeyPress={onKeyPressField}
                  maxLength={50}
                />
              </FormField>
            </Box>
            <Box
              css={
                {
                  display: 'flex',
                  flexDirection: 'column',
                  padding: '$one $none',
                } as GDSStyleObject
              }
            >
              <FormField
                id="examinerState"
                label="State"
                statusIconLabel="Error"
                inputStatus={errors.examinerState ? 'error' : undefined}
                statusMessage={errors.examinerState ? 'State required.' : ''}
              >
                <Select
                  name="examinerState"
                  options={stateOption()}
                  placeholder="Please Select"
                  id="examinerState"
                  value={form.examinerState}
                  onChange={onUpdateField}
                  onBlur={onBlurField}
                  onKeyPress={onKeyPressField}
                />
              </FormField>
            </Box>
            <Box
              css={
                {
                  display: 'flex',
                  flexDirection: 'column',
                  padding: '$one $none',
                } as GDSStyleObject
              }
            >
              <FormField
                id="examinerZipCode"
                label="Zip Code"
                statusIconLabel="Error"
                inputStatus={errors.examinerZipCode ? 'error' : undefined}
                statusMessage={errors.examinerZipCode ? exZipCodeError : ''}
              >
                <TextInput
                  pattern="[0-9]*"
                  name="examinerZipCode"
                  value={form.examinerZipCode}
                  id="examinerZipCode"
                  onChange={onUpdateField}
                  maxLength={5}
                  onBlur={onBlurField}
                  onKeyPress={onKeyPressField}
                />
              </FormField>
            </Box>
            <Box
              css={
                {
                  display: 'flex',
                  flexDirection: 'column',
                  padding: '$one $none',
                } as GDSStyleObject
              }
            >
              <FormField
                id="examinerSLN"
                label="State License Number (Optional)"
              >
                <TextInput
                  name="examinerSLN"
                  id="examinerSLN"
                  value={form.examinerSLN}
                  onChange={onUpdateField}
                  maxLength={50}
                />
              </FormField>
            </Box>
            <Box
              css={
                {
                  display: 'flex',
                  flexDirection: 'column',
                  padding: '$one $none',
                } as GDSStyleObject
              }
            >
              <FormField
                id="examinerPhoneNumber"
                label="Phone Number"
                statusIconLabel="Error"
                inputStatus={errors.examinerPhoneNumber ? 'error' : undefined}
                statusMessage={errors.examinerPhoneNumber ? exPhoneError : ''}
              >
                <TextInput
                  name="examinerPhoneNumber"
                  id="examinerPhoneNumber"
                  value={form.examinerPhoneNumber}
                  onChange={onUpdateField}
                  onBlur={onBlurField}
                  onKeyPress={onKeyPressField}
                  maxLength={14}
                />
              </FormField>
            </Box>
          </Box>
          <Box
            css={
              {
                marginTop: '$two',
                marginBottom: '$one',
              } as GDSStyleObject
            }
          >
            <HeadingText
              level="3"
              size={{
                '@initial': 'xl',
                '@mobile': 'lg',
                '@mobileLandscape': 'lg',
                '@tablet': 'xl',
                '@laptop': 'xl',
                '@desktop': 'xl',
              }}
            >
              Dispenser&apos;s Information
            </HeadingText>
            <UtilityText>
              <p>
                Fill out the dispenser information if the claims you are
                submitting include dispenser services.
              </p>
              <p>
                Is the dispenser&apos;s information the same as the Examiner?
              </p>
            </UtilityText>
            <FormField
              id="isPolicyHolderPatient"
              label=""
              statusIconLabel="Error"
              inputStatus={errors.isDispenserSame ? 'error' : undefined}
              statusMessage={errors.isDispenserSame ? isDisSameError : ''}
            >
              <Fieldset
                css={
                  {
                    display: 'flex',
                    maxWidth: '436px',
                  } as GDSStyleObject
                }
                legend={undefined}
              >
                <Radio
                  id="isDispenserSame-1"
                  name="isDispenserSame"
                  checked={form.isDispenserSame === 'YES'}
                  value={IS_POLICY_HOLDER_PATIENT.YES}
                  label={IS_POLICY_HOLDER_PATIENT.YES}
                  onChange={updateIsDispenserSame}
                />
                <Radio
                  id="isDispenserSame-2"
                  name="isDispenserSame"
                  checked={form.isDispenserSame === 'NO'}
                  value={IS_POLICY_HOLDER_PATIENT.NO}
                  label={IS_POLICY_HOLDER_PATIENT.NO}
                  onChange={updateIsDispenserSame}
                />
              </Fieldset>
            </FormField>
          </Box>
          {form.isDispenserSame === 'NO' && (
            <Box>
              <Box
                css={
                  {
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '$one $none',
                  } as GDSStyleObject
                }
              >
                <FormField
                  id="dispenserName"
                  label="Dispenser Name (First, MI, Last)"
                  statusIconLabel="Error"
                  inputStatus={errors.dispenserName ? 'error' : undefined}
                  statusMessage={
                    errors.dispenserName ? "Dispenser's name is required." : ''
                  }
                >
                  <TextInput
                    name="dispenserName"
                    id="dispenserName"
                    value={form.dispenserName}
                    onChange={onUpdateField}
                    onBlur={onBlurField}
                    onKeyPress={onKeyPressField}
                    maxLength={50}
                  />
                </FormField>
              </Box>
              <Box
                css={
                  {
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '$one $none',
                  } as GDSStyleObject
                }
              >
                <FormField
                  id="dispenserAddressLine1"
                  label="Dispenser Address Line 1"
                  statusIconLabel="Error"
                  inputStatus={
                    errors.dispenserAddressLine1 ? 'error' : undefined
                  }
                  statusMessage={
                    errors.dispenserAddressLine1
                      ? "Dispencers's address line 1 required"
                      : ''
                  }
                >
                  <TextInput
                    name="dispenserAddressLine1"
                    id="dispenserAddressLine1"
                    value={form.dispenserAddressLine1}
                    onChange={onUpdateField}
                    maxLength={50}
                    onBlur={onBlurField}
                    onKeyPress={onKeyPressField}
                  />
                </FormField>
              </Box>
              <Box
                css={
                  {
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '$one $none',
                  } as GDSStyleObject
                }
              >
                <FormField
                  id="dispenserAddressLine2"
                  label="Dispenser Address Line 2 (Optional)"
                >
                  <TextInput
                    name="dispenserAddressLine2"
                    id="dispenserAddressLine2"
                    value={form.dispenserAddressLine2}
                    onChange={onUpdateField}
                    maxLength={50}
                  />
                </FormField>
              </Box>
              <Box
                css={
                  {
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '$one $none',
                  } as GDSStyleObject
                }
              >
                <FormField
                  id="dispenserCity"
                  label="City"
                  statusIconLabel="Error"
                  inputStatus={errors.dispenserCity ? 'error' : undefined}
                  statusMessage={errors.dispenserCity ? 'City required.' : ''}
                >
                  <TextInput
                    name="dispenserCity"
                    id="dispenserCity"
                    value={form.dispenserCity}
                    onChange={onUpdateField}
                    onBlur={onBlurField}
                    onKeyPress={onKeyPressField}
                    maxLength={50}
                  />
                </FormField>
              </Box>
              <Box
                css={
                  {
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '$one $none',
                  } as GDSStyleObject
                }
              >
                <FormField
                  id="dispenserState"
                  label="State"
                  statusIconLabel="Error"
                  inputStatus={errors.dispenserState ? 'error' : undefined}
                  statusMessage={errors.dispenserState ? 'State required.' : ''}
                >
                  <Select
                    name="dispenserState"
                    options={stateOption()}
                    placeholder="Please Select"
                    id="dispenserState"
                    value={form.dispenserState}
                    onChange={onUpdateField}
                    onBlur={onBlurField}
                    onKeyPress={onKeyPressField}
                  />
                </FormField>
              </Box>
              <Box
                css={
                  {
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '$one $none',
                  } as GDSStyleObject
                }
              >
                <FormField
                  id="dispenserZipCode"
                  label="Zip Code"
                  statusIconLabel="Error"
                  inputStatus={errors.dispenserZipCode ? 'error' : undefined}
                  statusMessage={errors.dispenserZipCode ? disZipCodeError : ''}
                >
                  <TextInput
                    pattern="[0-9]*"
                    name="dispenserZipCode"
                    id="dispenserZipCode"
                    value={form.dispenserZipCode}
                    onChange={onUpdateField}
                    maxLength={5}
                    onBlur={onBlurField}
                    onKeyPress={onKeyPressField}
                  />
                </FormField>
              </Box>
              <Box
                css={
                  {
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '$one $none',
                  } as GDSStyleObject
                }
              >
                <FormField
                  id="dispenserSLN"
                  label="State License Number (Optional)"
                >
                  <TextInput
                    name="dispenserSLN"
                    id="dispenserSLN"
                    value={form.dispenserSLN}
                    onChange={onUpdateField}
                    maxLength={50}
                  />
                </FormField>
              </Box>
              <Box
                css={
                  {
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '$one $none',
                  } as GDSStyleObject
                }
              >
                <FormField
                  id="dispenserPhoneNumber"
                  label="Phone Number"
                  statusIconLabel="Error"
                  inputStatus={
                    errors.dispenserPhoneNumber ? 'error' : undefined
                  }
                  statusMessage={
                    errors.dispenserPhoneNumber ? disPhoneError : ''
                  }
                >
                  <TextInput
                    name="dispenserPhoneNumber"
                    id="dispenserPhoneNumber"
                    value={form.dispenserPhoneNumber}
                    onChange={onUpdateField}
                    onBlur={onBlurField}
                    onKeyPress={onKeyPressField}
                    maxLength={14}
                  />
                </FormField>
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </StackLayout>
  );
}
